import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { ProductId } from "@@/shared/products/product-id";
import type { Except } from "type-fest";
import type { DiscountId } from "../discount-id";
import type { SaleId} from "./sale-id";
import { createSaleId } from "./sale-id";

type SaleForProduct = {
    _id: SaleId;
    _type: "SALE";
    _createdAt: IsoAndUnixTimestamp;
    type: "SALE_FOR_PRODUCT";
    discountId: DiscountId;
    productId: ProductId;
    expireAt: Date;
};

type FactoryParams = Except<
    SaleForProduct,
    "_id" | "_type" | "type" | "_createdAt"
>;
const createSaleForProduct = (params: FactoryParams): SaleForProduct => {
    return {
        ...params,
        _id: createSaleId(),
        _type: "SALE",
        _createdAt: nowIsoAndUnix(),
        type: "SALE_FOR_PRODUCT",
    };
};

export { createSaleForProduct };
export type { SaleForProduct };
